import { useSelector, useDispatch } from "react-redux";

import { showOrHideModal } from "redux/slices/modals";

function useAddCompatibilityModal(props) {
  const addCompatibilityModalIsOpen = useSelector(
    (state) => state.modals.addCompatibilityModalIsOpen
  );
  const dispatch = useDispatch();

  const showAddCompatibilityModal = (props) => {
    dispatch(
      showOrHideModal({
        addCompatibilityModalIsOpen: true,
        addCompatibilityModalProps: props ? props : null,
      })
    );
  };

  const hideAddCompatibilityModal = () => {
    dispatch(
      showOrHideModal({
        addCompatibilityModalIsOpen: false,
        addCompatibilityModalProps: null,
      })
    );
  };

  return {
    addCompatibilityModalIsOpen,
    showAddCompatibilityModal,
    hideAddCompatibilityModal,
  };
}

export default useAddCompatibilityModal;
